import { useDispatch } from "react-redux";
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { eliminarNotificacion } from "../services/notificaciones.service";

import { dangerNotification } from '../../../redux/slices/ui';

export const useRemove = () => {

    const dispatch = useDispatch();

    const queryClient = useQueryClient();

    const removeMutation = useMutation({
        mutationFn: eliminarNotificacion,
        onSuccess: (notificacion, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ['notificaciones'], exact: false });
        },
        onError: (error, variables, context) => {
            dispatch(dangerNotification(error.message));
            // dispatch(dangerNotification(error.msg.message));
        }
    });

    return {
        removeMutation,
    }
}